import React from 'react';

// Vehicular assistance icon for ACCH: traced car (inherits theme color via currentColor)
// with a fixed blue "+" badge (#0956FF). Non-square source viewBox kept from the traced art.
const DirectionsCarPlusIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="60 4 324 324"
    width="1em"
    height="1em"
    style={{ fontSize: '1.5rem' }}
  >
    <g
      transform="translate(0.000000,392.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M2841 3524 c-166 -44 -294 -172 -345 -343 -9 -30 -16 -72 -16 -92 l0
      -38 -457 -3 -458 -3 -55 -26 c-62 -30 -123 -86 -151 -142 -11 -20 -58 -148
      -104 -284 -47 -135 -87 -248 -90 -251 -3 -3 -5 19 -5 49 0 79 -16 128 -46 139
      -32 13 -176 12 -229 0 -55 -13 -65 -31 -65 -120 0 -115 10 -123 180 -150 108
      -18 109 -19 59 -76 -23 -27 -54 -74 -68 -104 -26 -55 -26 -55 -26 -330 0 -306
      1 -309 68 -350 31 -19 60 -20 1180 -20 1264 0 1197 -3 1237 62 19 31 20 50 20
      299 0 317 -4 338 -85 434 -63 73 -69 66 80 91 139 22 141 24 148 126 6 100 -4
      122 -65 139 -62 16 -224 8 -245 -13 -11 -11 -18 -42 -22 -92 -4 -41 -9 -77
      -12 -80 -3 -3 -25 56 -50 131 -32 100 -41 137 -31 141 29 9 119 85 154 130
      221 278 85 687 -257 777 -73 19 -173 18 -244 -1z m189 -284 l0 -120 120 0 120
      0 0 -65 0 -65 -120 0 -120 0 0 -120 0 -120 -65 0 -65 0 0 120 0 120 -120 0
      -120 0 0 65 0 65 120 0 120 0 0 120 0 120 65 0 65 0 0 -120z m-503 -398 c74
      -161 247 -272 423 -272 l68 0 26 -65 c31 -79 33 -120 7 -135 -13 -7 -292 -10
      -835 -10 -803 0 -816 0 -836 20 -11 11 -20 26 -20 33 0 18 167 425 186 454
      l14 23 473 0 472 0 22 -48z m-1083 -792 c131 -45 180 -96 178 -187 0 -58 -32
      -107 -88 -133 -40 -20 -57 -22 -177 -18 -156 4 -188 16 -225 88 -19 37 -23 57
      -20 112 4 75 21 107 79 147 31 21 41 23 114 18 44 -3 107 -15 139 -27z m1796
      12 c59 -29 80 -73 80 -162 0 -84 -17 -122 -73 -164 -26 -19 -42 -21 -175 -21
      -121 0 -153 3 -179 17 -104 58 -107 207 -5 271 108 68 278 97 352 59z m-635
      -237 c32 -31 32 -59 0 -91 l-25 -25 -364 3 c-342 3 -365 4 -385 22 -27 24 -27
      70 -1 96 19 19 33 20 385 20 l366 0 24 -25z"
      />
      <path
        d="M1056 1294 c-13 -12 -16 -41 -16 -145 l0 -129 34 -38 34 -37 165 -3
      c185 -4 212 3 247 61 17 27 20 51 20 147 0 171 17 160 -250 160 -185 0 -221
      -2 -234 -16z"
      />
      <path
        d="M2910 1291 c-5 -11 -10 -76 -10 -145 l0 -126 34 -38 34 -37 164 -3
      c140 -2 168 0 198 15 55 28 70 69 70 198 0 166 17 155 -255 155 -212 0 -225
      -1 -235 -19z"
      />
    </g>
    <circle cx="296" cy="86.5" r="52" fill="#0956FF" />
    <path d="M296 60 V113 M269 86.5 H323" stroke="#ffffff" strokeWidth="10" strokeLinecap="round" />
  </svg>
);

export default DirectionsCarPlusIcon;
